import { Attributes, DateUtils, EnumHelper, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export enum DateFilterType {
    LastTransaction = 1,
    ActiveInPeriod = 2,
    TradeDate = 3,
    SettledDate = 4,
}

EnumHelper.decorateEnum(DateFilterType, d => {
    d.describe(DateFilterType.LastTransaction, "Last Transaction", "Returns trades where the last (final) transaction date is between the start and end date.");

    d.describe(DateFilterType.ActiveInPeriod, "Active in Period", "Returns trades which were active between the start and end date, even if no transactions occured during this period.\n" + 
        "Note: the same trades may appear in multiple date ranges since the filter is matching a range against a range, rather than a point in time.");

    d.describe(DateFilterType.TradeDate, "Trade Date", "Returns trades where the trade accounting date (usually created date) is between the start and end date.");

    d.describe(DateFilterType.SettledDate, "Settled Date", "Returns trades where the settled date is between the start and end date. Only settled trades will be returned.");
})

export abstract class TradesCriteria extends Model.CriteriaBase {

    @Attributes.Nullable()
    public payrollId: number | null = null;

    @Attributes.Nullable()
    public companyId: number | null = null;

    @Attributes.Nullable()
    public groupCompanyId: number | null = null;

    @Attributes.Nullable()
    public incentiveSchemeId: number | null = null;

    @Attributes.Display("Participant")
    public participantId: string | null = "";
    
    public participantName: string = "";
}

export class CompletedTradesCriteria extends TradesCriteria {
    static typeName = "CompletedTradesCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    public dateFilterType: DateFilterType = DateFilterType.LastTransaction;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date = DateUtils.monthStart(new Date());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date = DateUtils.today();

    public settledOnly: boolean = false;

    public includeSecondments: boolean = false;
}
